import { FC, useEffect, useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import useSwr from 'swr';
import toast from 'react-hot-toast';

import { fetchIdea } from '@utils/Poll';
import { useAuth } from '@hooks/Auth';
import { listUsers } from '@sdk/managers/UsersManager';
import HeaderImage from '@components/elements/HeaderImage';
import Logo from '@images/logo.png';
import { CompanyRole } from '@sdk/API';
import { getIdeaPledgeStripeChargeById } from '@sdk/managers/PaymentManager';
import { DEFAULT_USER_FIELDS } from '@utils/User';
import { getIdeaPledgeByIDQuery } from '@sdk/managers/IdeaManager';
const getPledges = async (id: string) => {
  const res = await getIdeaPledgeStripeChargeById(id);

  const cc = await Promise.all(
    (res || []).map(async (item) => {
      const temp = (await getIdeaPledgeByIDQuery(['title', 'price'], {
        id: item.ideaPledgeID,
      })) as any;
      return { ...item, pledgeData: temp?.data?.result };
    })
  );
  console.log(cc);
  return cc;
};

const PollPledgesPage: FC = () => {
  const history = useHistory();
  const {
    params: { pollId },
  } = useRouteMatch<{
    pollId: string;
  }>();
  const { user, company, loading } = useAuth();

  const { data, error } = useSwr(
    pollId && loading === false ? [pollId] : null,
    getPledges,
    {
      revalidateOnFocus: false,
      onError: (err, key) => {
        console.log('Failed to fetch pledges', { key }, err);
        toast.error(
          err?.message || err?.errors?.[0]?.message || 'Failed to fetch pledges'
        );
      },
    }
  );

  const [info, setInfo] = useState<any>();

  const fetchI = async () => {
    const res = await fetchIdea(pollId);
    if (!res) {
      history.replace(`/idea/${pollId}`);
    }
    setInfo(res);
  };

  useEffect(() => {
    if (pollId) fetchI();
  }, [pollId]);

  useEffect(() => {
    if (info) {
      console.log(data);
      const ownerPermission =
        user?.username === info?.owner ||
        (company &&
          company.companyID === info.companyID &&
          (company?.role === CompanyRole.ADMIN ||
            company.role === CompanyRole.REPRESENTATIVE));

      if (!ownerPermission) history.replace(`/idea/${pollId}`);
    }
  }, [company, history, info, pollId, user]);

  let content;
  let leftContent;
  let header;
  if (error?.code === 'NotFound') {
    content = (
      <div className="pt-32">
        <div className="flex flex-col items-center justify-center px-4 py-24 mx-4 text-center bg-white shadow-r-salmon-md">
          <h1 className="text-3xl sm:text-4xl">Idea is no longer available.</h1>
          <p>The Idea has been deleted or this is an invalid Idea.</p>

          <div className="mt-24">
            <img src={Logo} alt="migthypoll" />
          </div>
        </div>
      </div>
    );
  } else {
    header = (
      <>
        <HeaderImage
          title={info?.title || ''}
          titleSize={(info?.title?.length || 0) > 15 ? 40 : 55}
          image={info?.image?.url || 'image'}
          alt="poll picture"
        />
      </>
    );
    leftContent = (
      <div className="flex flex-col mx-4 my-4 space-y-4 lg:mr-0 lg:ml-4">
        {/* <div className="px-4 py-4 text-white bg-black">
          <h3 className="mb-2 text-lg text-white">Swing Vote</h3>
          <p className="pb-2">
            The poll ended in a tie, you will have a <u>Swing Vote</u>. It will
            determine the winner to proceed to pledging period.
          </p>
        </div> */}
        <div className="px-4 py-4 text-white bg-black">
          <h3 className="mb-2 text-lg text-white">Total Pledges</h3>
          <div className="poll-detail-votes">
            <div>{data?.length || 0}</div>
            <div>Pledges</div>
          </div>
        </div>
      </div>
    );

    content = (
      <div className="flex flex-col mx-4 my-4 space-y-4 lg:mr-4 lg:ml-0">
        <div className="px-4 pt-4 pb-8 space-y-4 text-white bg-black divide-y divide-solid">
          {(data?.length || 0) > 0 ? (
            <div className="flex w-full">
              <div style={{ width: '40%' }}>Email</div>
              <div style={{ width: '40%' }} className=" pl-2">
                Pledge
              </div>
              <div style={{ width: '20%' }} className=" pl-2">
                Phone
              </div>
            </div>
          ) : (
            <div>Idea has no pledges.</div>
          )}
          {data?.map((cc: any) => {
            return (
              <div key={`pledged-user-${user.username}`} className="flex">
                <div style={{ width: '40%' }} className="break-all">
                  {cc?.user?.email}
                </div>
                <div style={{ width: '40%' }} className="pl-2 break-all">
                  {cc.pledgeData?.title}
                  <br />
                  <span style={{ opacity: 0.7 }}>{cc.pledgeData?.price}</span>
                </div>
                <div style={{ width: '20%' }} className="pl-2 break-all">
                  {cc.user?.phone}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen overflow-x-hidden overflow-y-scroll bg-fixed bg-gray-darkest poll-x-pattern">
      {header}
      <div className="flex flex-col gap-4 mx-auto lg:container xl:gap-8 lg:flex-row">
        <div className="w-full lg:min-h-screen lg:sticky lg:top-0 lg:w-72">
          {leftContent}
        </div>
        <div className="flex flex-1">
          <div className="flex-1 pb-24">{content}</div>
        </div>
      </div>
    </div>
  );
};

export default PollPledgesPage;
